import { type ThemeMode, useTheme } from "../../design-system/useTheme";

const nextMode: Record<ThemeMode, ThemeMode> = {
  light: "dark",
  dark: "system",
  system: "light",
};

const labels: Record<ThemeMode, string> = {
  light: "ライト",
  dark: "ダーク",
  system: "システム",
};

const icons: Record<ThemeMode, string> = {
  light: "☀️",
  dark: "🌙",
  system: "🖥️",
};

export function ThemeToggle(): JSX.Element {
  const { mode, setMode } = useTheme();
  const next = nextMode[mode];
  const label = `テーマ: ${labels[mode]}。クリックして ${labels[next]} に切替`;

  return (
    <button
      type="button"
      aria-label={label}
      title={`現在: ${labels[mode]} / 次: ${labels[next]}`}
      onClick={() => setMode(next)}
      className="inline-flex h-10 min-h-11 w-10 shrink-0 items-center justify-center rounded-md text-lg text-text-secondary transition hover:bg-bg hover:text-text-primary focus:outline-none focus:ring-2 focus:ring-[var(--color-focus-ring)]"
    >
      <span aria-hidden="true">{icons[mode]}</span>
    </button>
  );
}
